export default {
  name: 'summary-detail',
  components: {},
  props: [],
  data () {
    return {
      loading: false,
      date_now: this.$moment(),
      users: null,
      checklist: {},
      summary: {}
    }
  },
  computed: {
    checklist_users() {
      return this.$store.getters["Audit/getUserOfChecklist"];
    }
  },
  mounted () {
    this.$loading.start()
    // this.loading = true
    Promise.all([
      this.$store.dispatch('Checklist/showChecklist', {checklist: {id: this.$route.params.checklist_id}}),
      this.$store.dispatch('Summary/showSummary', {checklist: {id: this.$route.params.checklist_id}, summary: {id: this.$route.params.summary_id}}),
      // this.$store.dispatch('Audit/getUserOfChecklist', {checklist: {id: this.$route.params.checklist_id}})
    ]).then(res => {
      this.checklist = res[0]
      this.summary = res[1]
      this.users = res[3]
      this.$loading.complete()
      this.loading = false
    }).catch(errors => {
      this.$loading.fail()
      this.loading = false
    })
  },
  methods: {
    print () {
      var innerContents = document.getElementById('page').innerHTML
		  var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
		  popupWinindow.document.open()
		  popupWinindow.document.write('<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"><link rel="stylesheet" href="/static/bootstrap.css"/><link rel="stylesheet" type="text/css" href="/static/print.css" /><link rel="stylesheet" type="text/css" href="/static/style.css" /></head><body onload="window.print()">' + innerContents + '</html>')
		  popupWinindow.document.close()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/view/summary-detail/summary-detail.js